import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate, fmtDA } from "@/lib/format";

const COLS = [["Valeur douane", "valeur_douane"], ["Droits", "droits"], ["Transitaire HT", "transitaire"], ["Frais HT", "frais"],
  ["Coût de revient", "cout_total"], ["TVA récupérable", "tva_recuperable"], ["Total décaissé", "total_decaisse"]];

export const D10Recap = ({ societeId, refresh }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/douane/recap", { params: { societe_id: societeId || "all" } }).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [societeId, refresh]);
  if (!rows.length) return null;
  return (
    <div className="rounded-xl border bg-card p-5 mt-5" data-testid="d10-recap">
      <h3 className="font-heading font-bold">Coût total par importation</h3>
      <p className="text-xs text-muted-foreground mb-3">Coût de revient = valeur en douane + droits + transitaire HT + frais HT (la TVA, récupérable dans le G50, est indiquée à part).</p>
      <div className="overflow-x-auto"><table className="w-full text-sm min-w-[1100px]">
        <thead><tr className="text-left text-muted-foreground border-b"><th className="py-2 pr-2 font-medium">D10</th><th className="py-2 pr-2 font-medium">Marchandise</th>
          {COLS.map(([h]) => <th key={h} className="py-2 pr-2 font-medium text-right">{h}</th>)}
          <th className="py-2 pr-2 font-medium text-right">Quantité</th><th className="py-2 pr-2 font-medium text-right">Coût / unité</th></tr></thead>
        <tbody className="divide-y">{rows.map((r) => (
          <tr key={r.id} data-testid={`d10-recap-row-${r.id}`}>
            <td className="py-2 pr-2 font-medium whitespace-nowrap">{r.numero} <span className="text-xs text-muted-foreground">{fmtDate(r.date)}</span></td>
            <td className="py-2 pr-2">{r.marchandise || "—"}</td>
            {COLS.map(([h, k]) => <td key={k} className={`py-2 pr-2 text-right font-mono whitespace-nowrap ${k === "cout_total" ? "font-semibold" : ""}`}>{fmtDA(r[k])}</td>)}
            <td className="py-2 pr-2 text-right whitespace-nowrap">{r.quantite_kg ? `${r.quantite_kg} ${r.unite}` : "—"}</td>
            <td className="py-2 pr-2 text-right font-mono font-semibold whitespace-nowrap" data-testid={`d10-recap-kg-${r.id}`}>{r.cout_kg ? `${fmtDA(r.cout_kg)} / ${r.unite}` : "Lier une entrée de stock"}</td>
          </tr>))}</tbody>
      </table></div>
    </div>
  );
};
